import type {
  SearcherRegistration,
  SearchResult,
  SearcherConfig,
} from "@pineseed/gui/types";

/**
 * Chat Searcher
 * STRICT RULE: Contains ONLY business logic - no UI imports, no direct atom mutations
 * Implements search functionality for chat messages
 */

export class ChatSearcher {
  private static instance: ChatSearcher;
  private config: SearcherConfig = {
    type: "chat",
    title: "Chat",
    icon: "message-circle",
    description: "Search chat messages",
    enabled: true,
  };

  public static getInstance(): ChatSearcher {
    if (!ChatSearcher.instance) {
      ChatSearcher.instance = new ChatSearcher();
    }
    return ChatSearcher.instance;
  }

  /**
   * Get searcher registration for the search manager
   */
  public getRegistration(): SearcherRegistration {
    return {
      config: this.config,
      search: this.search.bind(this),
    };
  }

  /**
   * Search chat messages
   */
  public async search(query: string): Promise<SearchResult[]> {
    if (!query.trim()) {
      return [];
    }

    // TODO: Implement actual chat message search integration
    return [];
  }

  /**
   * Enable/disable this searcher
   */
  public setEnabled(enabled: boolean): void {
    this.config.enabled = enabled;
  }

  /**
   * Get searcher configuration
   */
  public getConfig(): SearcherConfig {
    return { ...this.config };
  }
}

// Singleton instance
export const chatSearcher = ChatSearcher.getInstance();
